import React from 'react';
import { Typography, Button, Divider, Switch } from 'antd';
import Form from 'components/Form';
import { POST } from 'utils/API';
import { withData } from 'utils/DataContext';
const { Title } = Typography;

class SignIn extends React.Component {
  static defaultProps = {
    member: true,
  };

  constructor(props) {
    super(props);
    let { member } = props;
    let { email = '' } = props.match.params;
    this.state = {
      member,
      email,
      loading: false,
      error: '',
    };
  }

  signIn = ({ username, password }) => {
    this.setState({ loading: true, error: '' });

    POST('auth/login', { username, password })
      .then(({ data }) => {
        this.props.setUser({
          ...data,
          token: data.token,
          accesstoken: data.token,
          emailaddress: username,
          email: username,
          username: username,
          type: data.profile.name === 'member' ? 'MEMBER' : 'ADMIN',
        });
      })
      .catch((error) => {
        this.setState({ loading: false, error });
      });
  };

  render = () => {
    let { loading, error, email, member } = this.state;
    return (
      <div className='public-form-container'>
        <Title level={2}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div style={{ display: 'flex', flex: 1 }}>
              {member ? 'Member ' : ''}Sign In{' '}
            </div>
            {this.props.location &&
              this.props.location.pathname.includes('sign-in') && (
                <Switch
                  disabled={loading || error !== ''}
                  checked={!member}
                  checkedChildren='Staff'
                  unCheckedChildren='Member'
                  onChange={(checked) => this.setState({ member: !checked })}
                />
              )}
          </div>
        </Title>
        <Form
          noLabels
          onChange={(e) => this.setState({ error: '' })}
          error={error}
          loading={loading}
          action={{
            text: 'SIGN IN',
            type: 'primary',
            icon: 'unlock',
            extra: (
              <Button
                type='link'
                onClick={() => this.props.history.push('/reset-password')}
              >
                Forgot password?
              </Button>
            ),
          }}
          fields={[
            {
              name: 'username',
              placeholder: member ? 'TIN...' : 'Email...',
              value: email,
              rules: member
                ? [{ required: true, message: 'TIN is required!' }]
                : [
                    {
                      required: true,
                      message: 'The email address is required!',
                    },
                    { type: 'email', message: 'Invalid email!' },
                  ],
            },
            {
              name: 'password',
              placeholder: 'Password...',
              value: '',
              password: true,
              rules: [{ required: true, message: 'The password is required!' }],
            },
          ]}
          onSubmit={this.signIn}
        />
        {member && (
          <>
            <Divider>OR</Divider>
            <Button
              block
              icon='user-add'
              onClick={() => {
                this.props.history.push('/sign-up');
              }}
            >
              REGISTER AS NEW MEMBER
            </Button>
          </>
        )}
      </div>
    );
  };
}

export default withData(SignIn);
